
import { useState } from "react";
import QueueMusicSharpIcon from '@mui/icons-material/QueueMusicSharp';
import Tooltip from "@mui/material/Tooltip";


interface DownloadPlaylistActionProps {
  event: {
    id?: string;
    location?: string;
    start_date?: string;
    performance_type?: string | null;
  } | null;
  hasSongsUploaded: boolean;
}

function DownloadPlaylistAction({ event, hasSongsUploaded }: DownloadPlaylistActionProps) {
  const [_loading, setLoading] = useState(false);

  const handleDownloadPlaylist = async () => {
    const eventId = event?.id;
    try {
      setLoading(true);
      const token = localStorage.getItem('token'); 
      const response = await fetch(
        `${import.meta.env.VITE_API_URL}/events/${eventId}/music/playlist`,
        {
          method: "GET",
          headers: {
            'Authorization': `Bearer ${token}`,
          }
        }
      );
      
      if (!response.ok) console.error(`Download failed with status: ${response.status}`);
      
      const blob = await response.blob();
      //const fileName = `${event?.location?.replace(/\s+/g, '_')}_${event?.start_date}.m3u8`;
      const sanitizeFilePart = (value = "") =>
        value
        .normalize("NFKD")
        .replace(/[^\w\s,.-]/g, "")
        .replace(/\s+/g, " ")
        .trim();
      const safeLocation = sanitizeFilePart(event?.location);
      const fileName = `${safeLocation} ${event?.start_date?.replace(/[\\/:*?"<>|\s]+/g, '-')}.m3u8`;
      
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
    } catch (error) {
      console.error("❌ Failed to download playlist", error);
      alert("Failed to download playlist");
    } finally {
      setLoading(false);
    }
  };

  if (!event?.id) return null;

  const canDownloadPlaylist = hasSongsUploaded && event?.performance_type != null;

  return (
    <Tooltip 
      title={event?.performance_type == null ? "No entry numbers available yet" : ""}
      enterDelay={0} 
      leaveDelay={0}
    >
      <span>
        <button
          className="download-all-btn"
            onClick={(e) => {
              if (!hasSongsUploaded || event?.performance_type == null) {
                e.preventDefault();
                return;
              }
              handleDownloadPlaylist();
            }}
          disabled={!canDownloadPlaylist}
          style={{
            cursor: canDownloadPlaylist ? "pointer" : "not-allowed",
            opacity: canDownloadPlaylist ? 1 : 0.3,
          }}
        >
          <QueueMusicSharpIcon style={{ fontSize: '20px' }} />
          <span>
            {/* {loading ? 'Downloading...' : 'Download Playlist'} */}
            Playlist
          </span>
        </button>
      </span>
    </Tooltip>
  );
}

export default DownloadPlaylistAction;